<template>
    <form-group
        v-bind="form_group_props"
    >
        <template v-slot:read_only>
            <slot name="read_only">
                <label
                    v-if="has_label"
                    class="form-label"
                    :for="identifier"
                >
                    <slot name="label"></slot>
                </label>
                <base-link
                    v-if="!!value"
                    :href="value"
                    target="_blank"
                    :alt="translate('Open in new window')"
                    class="form-label disabled-field"
                >
                    <open-icon glyph="external-link-alt" />
                    {{ value }}
                </base-link>
                <label
                    v-else
                    class="form-label disabled-field"
                >&nbsp;</label>
            </slot>
        </template>
        <template v-slot:empty-value><slot name="empty-value"></slot></template>
        <template v-slot:label><slot name="label"></slot></template>
        <template v-slot:hint><slot name="hint"></slot></template>
        <url-input
            v-bind="input_props"
            v-on="$listeners"
        />
    </form-group>
</template>

<script>
import is_nibnut_component from "@/nibnut/mixins/IsNibnutComponent"

import FormGroup from "@/nibnut/components/Inputs/FormGroup"
import UrlInput from "@/custom/components/UrlInput"

export default {
    name: "FormUrlInput",
    mixins: [is_nibnut_component],
    components: {
        FormGroup,
        UrlInput
    },
    methods: {
    },
    computed: {
        has_label () {
            return this.has_slot("label")
        },
        form_group_props () {
            return {
                id: this.id,
                name: this.name,
                value: this.value,
                required: this.required,
                editable: this.editable,
                error: this.error,
                waiting: this.saving
            }
        },
        input_props () {
            const { saving, error, ...input_props } = this.$props
            return input_props
        }
    },
    props: {
        ...UrlInput.props,
        saving: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ""
        }
    }
}
</script>
